import { EMainProductCodeType } from '@webtrader/core/api/config/company';
import { EDataTestId } from '@webtrader/core/constants/test';
import i18n from '@webtrader/core/i18n';

export enum EChartSeries {
  LINE = 'line',
  LINE_ASK = 'lineAsk',
  CANDLESTICK = 'candlestick'
}

export const getInteractableSeries = (integration: EMainProductCodeType) => [
  EChartSeries.CANDLESTICK,
  EChartSeries.LINE,
  ...(integration === EMainProductCodeType.METATRADER5 ? [EChartSeries.LINE_ASK] : [])
];

export const getSeriesTextMap = (integration: EMainProductCodeType): Partial<Record<EChartSeries, () => string>> => ({
  [EChartSeries.CANDLESTICK]: () => i18n.t('Candlestick'),
  ...(integration === EMainProductCodeType.METATRADER5
    ? {
        [EChartSeries.LINE]: () => i18n.t('Line (Bid)'),
        [EChartSeries.LINE_ASK]: () => i18n.t('Line (Bid & Ask)')
      }
    : {
        [EChartSeries.LINE]: () => i18n.t('Line')
      })
});

export const seriesToTestIdMap: Record<EChartSeries, EDataTestId> = {
  [EChartSeries.LINE]: EDataTestId.CHART_SERIES_OPTION_LINE,
  [EChartSeries.LINE_ASK]: EDataTestId.CHART_SERIES_OPTION_LINE_ASK,
  [EChartSeries.CANDLESTICK]: EDataTestId.CHART_SERIES_OPTION_CANDLESTICK
};
